import { render, staticRenderFns } from "./ObjectDetailsForm.vue?vue&type=template&id=303dfe7e&"
import script from "./ObjectDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ObjectDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports